export const HOTJAR_ID = {
  AVON: {
    MEXICO: {
      HML: '2923753',
      PROD: '2923757'
    }
  }
}
